export default {
  path: '/case',
  name: 'case',
  component: () => import('@/pages/case'),
  children: [
    {
      path: 'list',
      name: 'case_list',
      component: () => import('@/pages/case/list')
    },
    {
      path: ':id',
      name: 'case_details',
      component: () => import('@/pages/case/details')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/case.js